module.exports = __webpack_public_path__ + "static/media/lock-solid.2518b92f.svg";